export const normalizeBookingStatus = (status: string): string => {
  // Convert any status format to the standard format (with underscore)
  return status.replace(/-/g, '_');
};

export const validStatuses = [
  "concept",
  "submitted",
  "approved",
  "waiting_for_goods",
  "goods_received_origin",
  "in_transit",
  "custom_clearance",
  "out_for_delivery",
  "delivered",
  "added_to_stock",
  "rejected",
  "cancelled",
  "archived"
] as const;

export type BookingStatus = typeof validStatuses[number];

export const statusColors: Record<BookingStatus, string> = {
  concept: "#faad14", // Yellow - draft
  submitted: "#1890ff", // Blue - in process
  approved: "#52c41a", // Green - approved
  rejected: "#f5222d", // Red - rejected
  waiting_for_goods: "#36cfc9", // Cyan - waiting
  goods_received_origin: "#722ed1", // Purple - goods received
  custom_clearance: "#722ed1", // Purple - customs
  out_for_delivery: "#13c2c2", // Cyan - delivery
  delivered: "#389e0d", // Green - delivered
  added_to_stock: "#73d13d", // Light green - added to stock
  in_transit: "#096dd9", // Blue - transit
  cancelled: "#ff4d4f", // Red - cancelled
  archived: "#8c8c8c", // Grey - archived
};

export const statusSteps: Record<BookingStatus, number> = {
  concept: 0,
  submitted: 1,
  approved: 2,
  waiting_for_goods: 3,
  goods_received_origin: 4,
  in_transit: 5,
  custom_clearance: 6,
  out_for_delivery: 7,
  delivered: 8,
  added_to_stock: 9,
  rejected: -1,
  cancelled: -1,
  archived: -1,
}; 